/* MV Sortiment assets/mv-sortiment.konto-profil.js - Agent A-4 - 2026-10-10 */
/*
 * Profil-Dialog und Profil auf der Kontoseite (Paket A-4 "Profil + CRM"). Plan docs/mv-vending/sortiment/planung/
 * plan-konto-fortschritt-2026-10-09.md (Vertrag Abschnitt 3: GET/PUT /profil; DELETE /profil aus A-1), Doku
 * _docs/a4-konto-profil.md. Inhaber 09.10.2026: "am besten beim Login paar Informationen zum Nutzer abfragen damit es
 * im CRM Sinn macht und den Nutzer auch drauf hinweisen dass wir die Infos kriegen".
 *
 * Eigene Teil-Datei statt Erweiterung von assets/mv-sortiment.konto.js: die Speicherschicht von A-2a bleibt byte-gleich
 * (ihre Doku und _tests/a2a-konto.test.mjs belegen sie per md5, Routenliste und Klassenliste). Im Buendel
 * (_build/konkat.sh, Byte-Reihenfolge) steht diese Datei VOR konto.js; MVKonto wird deshalb erst nach dem Buendel
 * aufgeloest (Mikrotask), dann haengt sich die API als MVKonto.profil an.
 *
 * API (window.MVKonto.profil, ebenso window.__mvSortiment.kontoProfil):
 *   eingeloggt()          -> boolean (window.mvKonto.eingeloggt und MVKonto.eingeloggt(); nach 401 false)
 *   lesen(optionen)       -> Promise<{ ok: true, profil: object|null, aktualisiert_am, hinweis_gesehen_am }
 *                            | { ok: false, fehler, status, feld }>; einmal je Seite, { frisch: true } liest neu
 *   speichern(profil)     -> Promise<{ ok: true, profil, aktualisiert_am } | { ok: false, fehler, feld }>;
 *                            PUT /profil mit dem ganzen Datensatz (die sieben Felder des Vertrags)
 *   loeschen()            -> Promise<{ ok: true } | { ok: false, fehler }>; DELETE /profil
 *   oeffnen(optionen)     -> Dialog oeffnen, { modus: 'neu' | 'bearbeiten' }; false, wenn es nicht geht
 *   schliessen()          -> Dialog schliessen wie "Abbrechen"
 *   anzeigen(container)   -> Profil im Container [data-mv-konto-profil] der Kontoseite (Paket A-3) zeigen und aktuell
 *                            halten; optional data-mv-konto-profil-ebene="2|3|4" (Ueberschrift) oder "0" (ohne)
 *   pruefen()             -> Erstabfrage nach dem Login (siehe unten); Promise<Ergebnis als Text>
 *   on(ereignis, fn)      -> 'gelesen' | 'gespeichert' | 'geloescht' | 'fehler' | 'geoeffnet' | 'geschlossen';
 *                            liefert eine Abmelde-Funktion
 *
 * Erstabfrage: Auf einer Seite mit Login fragt pruefen() GET /profil, solange im Browser kein Merker steht
 * (localStorage['mv-konto-profil'] = { v: 1, status, am }, ausserhalb des Spiegel-Praefixes mv-konto:). Profil leer:
 * Dialog (Merker "gezeigt"); Profil da: Merker "vorhanden"; Konto nicht erreichbar: Merker "fehler" (neuer Versuch nach
 * 24 Stunden). "Spaeter", Escape und Schliessen setzen "spaeter", Speichern "vorhanden". Jede Seite ohne Login entfernt
 * den Merker: der naechste Login fragt wieder, solange das Profil leer ist - nicht bei jedem Seitenaufruf. Ohne nutzbaren
 * Browser-Speicher, im Theme-Editor, auf Warenkorb-, Konto-, Kasse- und Richtlinienseiten und bei offenem anderem Dialog
 * oeffnet sich nichts von selbst; die Kontoseite bietet den Dialog immer an.
 *
 * Proxy: window.mvKonto.basis ('/apps/mv') + '/profil'; fetch mit credentials same-origin, Accept application/json.
 * Keine Kunden-ID im Browser (die Person erkennt allein der App-Proxy), keine Profildaten im Browser-Speicher (der
 * Merker traegt nur Status und Zeit). Markup per DOM-Aufbau (createElement, kein HTML-Text), Ereignisse per Delegation auf document,
 * Waechter window.__mvSortiment. Unter Node (Tests) liefert die Datei die reinen Funktionen und erzeuge(umgebung).
 * Kommentare und Datei ASCII; sichtbare Texte als \u-Escapes (Textbausteine KTO-30 bis KTO-83 in der Doku).
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-10.1';
  var MERKER = 'mv-konto-profil';
  var MERKER_STATUS = ['vorhanden', 'gezeigt', 'spaeter', 'fehler'];
  var FEHLER_PAUSE_MS = 24 * 60 * 60 * 1000;
  var MAX_TEXT = 200;
  var ID = 'mv-konto-profil';
  var FELDER = ['firma', 'name', 'telefon', 'branche', 'anzahl_automaten', 'zeitraum', 'kontakt_ok'];
  var EREIGNISSE = ['gelesen', 'gespeichert', 'geloescht', 'fehler', 'geoeffnet', 'geschlossen'];
  var DATENSCHUTZ_URL = '/policies/privacy-policy';
  /* Warenkorb, Kasse, gehostete Kontoseiten, Login-Pruefung, Passwortseite, Richtlinien (auch mit Sprachpraefix) */
  var AUSGENOMMEN_RE = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:cart|checkouts?|account|challenge|password|policies)(?:\/|$)/i;
  var FOKUSSIERBAR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* Branchenliste wie die Branchenseiten (Werte laut A-1 regeln.ts BRANCHEN, Reihenfolge wie sections/mv-branchen) */
  var BRANCHEN = [
    ['bueros', 'B\u00fcro & Verwaltung'],
    ['fitnessstudios', 'Fitnessstudio'],
    ['schulen-hochschulen', 'Schule & Hochschule'],
    ['kliniken-pflege', 'Klinik & Pflege'],
    ['hotels', 'Hotel & Gastgewerbe'],
    ['produktion-werkstatt', 'Produktion & Werkstatt'],
    ['sonstiges', 'Sonstiger Standort']
  ];
  var ZEITRAEUME = [
    ['sofort', 'So bald wie m\u00f6glich'],
    ['3-monate', 'In den n\u00e4chsten drei Monaten'],
    ['spaeter', 'Sp\u00e4ter']
  ];

  /* Textbausteine KTO-30 bis KTO-83 (Doku Abschnitt 8); Zeitformat wie KTO-08 */
  var TEXT = {
    titel: 'Ein paar Angaben zu Ihrem Vorhaben',
    titelBearbeiten: 'Ihre Angaben bearbeiten',
    intro: 'Damit wir Sie passend beraten k\u00f6nnen, erz\u00e4hlen Sie uns kurz, was Sie vorhaben. Pflicht sind nur Firma und Standorttyp.',
    hinweisTitel: 'Das passiert mit Ihren Angaben',
    hinweis: 'Diese Angaben erh\u00e4lt MV Vending. Wir sehen sie zusammen mit der \u00dcbersicht Ihrer im Konto gespeicherten Werkzeuge und nutzen sie, um Ihr Vorhaben einzusch\u00e4tzen und Sie passend zu beraten.',
    hinweisAendernVor: '\u00c4ndern oder l\u00f6schen k\u00f6nnen Sie Ihre Angaben jederzeit unter ',
    werkzeuge: 'Meine Werkzeuge',
    hinweisAendernNach: '.',
    datenschutz: 'Mehr dazu in unserer Datenschutzerkl\u00e4rung',
    firma: 'Firma',
    name: 'Ihr Name',
    telefon: 'Telefon',
    telefonHilfe: 'F\u00fcr R\u00fcckfragen zu Ihrem Vorhaben.',
    branche: 'Standorttyp',
    anzahl: 'Geplante Anzahl Automaten',
    anzahlHilfe: 'Eine Sch\u00e4tzung gen\u00fcgt.',
    zeitraum: 'Zeitraum',
    bitteWaehlen: 'Bitte w\u00e4hlen',
    kontakt: 'Ja, MV Vending darf mich zu meinem Vorhaben kontaktieren.',
    kontaktHilfe: 'Freiwillig. Ihre Zustimmung k\u00f6nnen Sie jederzeit unter \u201eMeine Werkzeuge\u201c zur\u00fccknehmen.',
    pflicht: '(Pflicht)',
    speichern: 'Angaben speichern',
    spaeter: 'Sp\u00e4ter',
    abbrechen: 'Abbrechen',
    schliessen: 'Schlie\u00dfen',
    fehlerFirma: 'Bitte geben Sie Ihre Firma an.',
    fehlerBranche: 'Bitte w\u00e4hlen Sie einen Standorttyp.',
    fehlerAnzahl: 'Bitte geben Sie die Anzahl als ganze Zahl ein.',
    fehlerLang: 'Bitte k\u00fcrzen Sie diese Angabe.',
    fehlerFeld: 'Bitte pr\u00fcfen Sie diese Angabe.',
    fehlerAbgemeldet: 'Sie sind nicht mehr angemeldet. Bitte melden Sie sich erneut an.',
    anmelden: 'Anmelden',
    fehlerKonto: 'Ihre Angaben lassen sich gerade nicht speichern. Bitte versuchen Sie es sp\u00e4ter noch einmal.',
    fehlerNetz: 'Keine Verbindung. Bitte pr\u00fcfen Sie Ihre Internetverbindung und versuchen Sie es noch einmal.',
    fehlerZuViele: 'Gerade kommen zu viele Anfragen an. Bitte warten Sie einen Moment und versuchen Sie es dann noch einmal.',
    fehlerIntern: 'Das Speichern hat nicht geklappt. Bitte versuchen Sie es noch einmal.',
    gespeichert: 'Ihre Angaben sind gespeichert.',
    bereichTitel: 'Ihre Angaben',
    laedt: 'Ihre Angaben werden geladen \u2026',
    leer: 'Sie haben noch keine Angaben zu Ihrem Vorhaben hinterlegt.',
    ergaenzen: 'Angaben erg\u00e4nzen',
    bearbeiten: 'Angaben bearbeiten',
    loeschen: 'Angaben l\u00f6schen',
    rueckfrage: 'M\u00f6chten Sie Ihre Angaben wirklich l\u00f6schen? Ihre gespeicherten Werkzeuge bleiben erhalten.',
    loeschenJa: 'Ja, Angaben l\u00f6schen',
    geloescht: 'Ihre Angaben sind gel\u00f6scht.',
    fehlerLaden: 'Ihre Angaben lassen sich gerade nicht laden.',
    nochmal: 'Noch einmal versuchen',
    fehlerLoeschen: 'Das L\u00f6schen hat nicht geklappt. Bitte versuchen Sie es noch einmal.',
    zuletzt: 'Zuletzt ge\u00e4ndert:',
    keineAngabe: 'keine Angabe',
    ja: 'Ja',
    nein: 'Nein',
    kontaktKurz: 'Kontakt erw\u00fcnscht',
    anzahlKurz: 'Geplante Automaten',
    uhr: 'Uhr'
  };

  var BRANCHEN_WERTE = BRANCHEN.map(function (b) { return b[0]; });
  var ZEITRAUM_WERTE = ZEITRAEUME.map(function (z) { return z[0]; });

  /* Linien-Icons wie snippets/mv-icon.liquid (Pfade gleich, Test prueft das) */
  var ICONS = {
    schliessen: [['path', { d: 'M6 6l12 12M18 6L6 18' }]],
    info: [['circle', { cx: '12', cy: '12', r: '9' }], ['path', { d: 'M12 11v5.5M12 7.5h.01' }]]
  };

  // ===========================================================================================
  // Teil 1: reine Logik
  // ===========================================================================================

  function hat(o, k) {
    return !!o && Object.prototype.hasOwnProperty.call(o, k);
  }

  function istObjekt(x) {
    return !!x && typeof x === 'object' && Object.prototype.toString.call(x) !== '[object Array]';
  }

  function zeitWert(iso) {
    return typeof iso === 'string' && iso ? Date.parse(iso) : NaN;
  }

  function iso(x) {
    return isFinite(zeitWert(x)) ? x : null;
  }

  function zwei(n) {
    return (n < 10 ? '0' : '') + n;
  }

  // "14:32 Uhr" am selben Tag, sonst "09.10.2026, 14:32 Uhr" (Ortszeit des Browsers; wie zeitText in konto.js, KTO-08)
  function zeitText(isoText, jetzt) {
    var t = zeitWert(isoText);
    if (!isFinite(t)) return '';
    var d = new Date(t);
    var h = new Date(typeof jetzt === 'number' && isFinite(jetzt) ? jetzt : Date.now());
    var uhr = zwei(d.getHours()) + ':' + zwei(d.getMinutes()) + '\u00a0' + TEXT.uhr;
    if (d.getFullYear() === h.getFullYear() && d.getMonth() === h.getMonth() && d.getDate() === h.getDate()) return uhr;
    return zwei(d.getDate()) + '.' + zwei(d.getMonth() + 1) + '.' + d.getFullYear() + ', ' + uhr;
  }

  // Einzeilig wie das Backend (A-1 einzeilig): Steuerzeichen zu Leerzeichen, Leerraum zusammengefasst, getrimmt
  function einzeilig(text) {
    return String(text).replace(/[\u0000-\u001f\u007f-\u009f]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  // Laenge in Zeichen (Codepoints), wie das Backend zaehlt
  function laenge(text) {
    var n = 0;
    for (var i = 0; i < text.length; i++) {
      var c = text.charCodeAt(i);
      if (c >= 0xd800 && c <= 0xdbff && i + 1 < text.length) i += 1;
      n += 1;
    }
    return n;
  }

  function fehlerFuer(liste, feld) {
    for (var i = 0; i < liste.length; i++) if (liste[i].feld === feld) return liste[i];
    return null;
  }

  // Eingaben pruefen und in die Vertragsform bringen. werte: Rohwerte je Feld (Texte aus den Feldern, kontakt_ok
  // boolean). pflicht: Firma und Standorttyp muessen gesetzt sein (Inhaberfragen 429/437: nur im Dialog erzwungen).
  // Ergebnis { profil, fehler: [{ feld, art: 'pflicht' | 'lang' | 'zahl' | 'wert' }] } in Feldreihenfolge.
  function pruefeEingabe(werte, pflicht) {
    var w = istObjekt(werte) ? werte : {};
    var profil = { firma: null, name: null, telefon: null, branche: null, anzahl_automaten: null, zeitraum: null, kontakt_ok: false };
    var fehler = [];
    ['firma', 'name', 'telefon'].forEach(function (f) {
      if (w[f] === undefined || w[f] === null) return;
      var t = einzeilig(w[f]);
      if (!t) return;
      if (laenge(t) > MAX_TEXT) fehler.push({ feld: f, art: 'lang' });
      else profil[f] = t;
    });
    var b = w.branche === undefined || w.branche === null ? '' : String(w.branche).trim();
    if (b) {
      if (BRANCHEN_WERTE.indexOf(b) === -1) fehler.push({ feld: 'branche', art: 'wert' });
      else profil.branche = b;
    }
    var a = w.anzahl_automaten;
    a = a === undefined || a === null ? '' : String(a).trim();
    if (a) {
      if (!/^\d{1,3}$/.test(a) || Number(a) < 1) fehler.push({ feld: 'anzahl_automaten', art: 'zahl' });
      else profil.anzahl_automaten = Number(a);
    }
    var z = w.zeitraum === undefined || w.zeitraum === null ? '' : String(w.zeitraum).trim();
    if (z) {
      if (ZEITRAUM_WERTE.indexOf(z) === -1) fehler.push({ feld: 'zeitraum', art: 'wert' });
      else profil.zeitraum = z;
    }
    profil.kontakt_ok = w.kontakt_ok === true;
    if (pflicht) {
      if (!profil.firma && !fehlerFuer(fehler, 'firma')) fehler.push({ feld: 'firma', art: 'pflicht' });
      if (!profil.branche && !fehlerFuer(fehler, 'branche')) fehler.push({ feld: 'branche', art: 'pflicht' });
    }
    fehler.sort(function (x, y) { return FELDER.indexOf(x.feld) - FELDER.indexOf(y.feld); });
    return { profil: profil, fehler: fehler };
  }

  // Profil aus der Antwort von GET /profil: nur die sieben Felder, falsche Typen fallen weg
  function ausServer(p) {
    if (!istObjekt(p)) return null;
    var text = function (x) { return typeof x === 'string' && x.trim() ? x : null; };
    var n = p.anzahl_automaten;
    return {
      firma: text(p.firma),
      name: text(p.name),
      telefon: text(p.telefon),
      branche: text(p.branche),
      anzahl_automaten: typeof n === 'number' && isFinite(n) && Math.floor(n) === n ? n : null,
      zeitraum: text(p.zeitraum),
      kontakt_ok: p.kontakt_ok === true
    };
  }

  // Merker im Browser: { v: 1, status, am }; "fehler" gilt 24 Stunden, alles andere bis zur naechsten Seite ohne Login
  function leseMerker(text, jetzt) {
    if (typeof text !== 'string' || !text) return null;
    var d;
    try { d = JSON.parse(text); } catch (e) { return null; }
    if (!istObjekt(d) || d.v !== 1 || MERKER_STATUS.indexOf(d.status) === -1) return null;
    if (d.status === 'fehler') {
      var t = zeitWert(d.am);
      if (!isFinite(t) || Math.abs(jetzt - t) > FEHLER_PAUSE_MS) return null;
    }
    return d.status;
  }

  function merkerText(status, jetzt) {
    return JSON.stringify({ v: 1, status: status, am: new Date(jetzt).toISOString() });
  }

  // Antwort des Proxys einordnen (Fehlercodes laut A-1: 400 ungueltig, 401, 403 signatur, 404, 413, 429, 5xx)
  function fehlerArt(r) {
    if (!r || r.netz) return 'netz';
    if (r.status === 401) return 'nicht_angemeldet';
    if (r.status === 403 || r.status === 404 || !r.daten) return 'konto';
    if (r.status === 400) return 'ungueltig';
    if (r.status === 413) return 'zu_gross';
    if (r.status === 429) return 'zu_viele';
    return 'intern';
  }

  function ausgenommen(pfad) {
    return typeof pfad === 'string' && AUSGENOMMEN_RE.test(pfad);
  }

  function beschriftung(liste, wert) {
    for (var i = 0; i < liste.length; i++) if (liste[i][0] === wert) return liste[i][1];
    return null;
  }

  // Anzeigewert eines Felds auf der Kontoseite
  function anzeigeWert(feld, profil) {
    var p = profil || {};
    if (feld === 'kontakt_ok') return p.kontakt_ok === true ? TEXT.ja : TEXT.nein;
    var v = p[feld];
    if (v === null || v === undefined || v === '') return TEXT.keineAngabe;
    if (feld === 'branche') return beschriftung(BRANCHEN, v) || TEXT.keineAngabe;
    if (feld === 'zeitraum') return beschriftung(ZEITRAEUME, v) || TEXT.keineAngabe;
    return String(v);
  }

  function fehlerText(art) {
    return {
      nicht_angemeldet: TEXT.fehlerAbgemeldet,
      konto: TEXT.fehlerKonto,
      netz: TEXT.fehlerNetz,
      zu_viele: TEXT.fehlerZuViele,
      zu_gross: TEXT.fehlerLang,
      ungueltig: TEXT.fehlerFeld
    }[art] || TEXT.fehlerIntern;
  }

  function feldFehlerText(feld, art) {
    if (art === 'pflicht') return feld === 'branche' ? TEXT.fehlerBranche : TEXT.fehlerFirma;
    if (art === 'zahl') return TEXT.fehlerAnzahl;
    if (art === 'lang') return TEXT.fehlerLang;
    return TEXT.fehlerFeld;
  }

  // ===========================================================================================
  // Teil 2: Schicht (erzeuge) - Umgebung u: konfig(), konto(), speicher(), holen(url, opt), jetzt(), dokument,
  // pfad(), editor(), Promise. Im Browser window.mvKonto, window.MVKonto, localStorage, fetch; in den Tests Attrappen.
  // ===========================================================================================

  function erzeuge(u) {
    var P = u.Promise || Promise;
    var hoerer = {};
    var abgemeldet = false;
    var kontoAus = false;
    var laufend = null;
    var stand = null;
    var speicherOk;
    var bereiche = [];
    var zaehler = 0;
    var dlg = null;
    var teile = null;
    var modus = null;
    var offen = false;
    var vorher = null;
    var sendet = false;
    var ansageGlobal = null;
    EREIGNISSE.forEach(function (n) { hoerer[n] = []; });

    function leer() { /* nichts */ }

    function jetztMs() {
      var t = typeof u.jetzt === 'function' ? u.jetzt() : Date.now();
      return typeof t === 'number' && isFinite(t) ? t : Date.now();
    }

    function dok() {
      return u.dokument || null;
    }

    // ------------------------------------------------------------------ Konfiguration (window.mvKonto, MVKonto)

    function konfig() {
      var k = null;
      try { k = typeof u.konfig === 'function' ? u.konfig() : null; } catch (e) { k = null; }
      return istObjekt(k) ? k : null;
    }

    function basis() {
      var k = konfig();
      var b = k && typeof k.basis === 'string' ? k.basis : '';
      return /^\/[A-Za-z0-9_\/-]*$/.test(b) && b.indexOf('//') === -1 ? b.replace(/\/+$/, '') : '';
    }

    function sichereUrl(x) {
      return typeof x === 'string' && /^(?:\/(?!\/)|https:\/\/)/.test(x) ? x : '';
    }

    function konto() {
      var k = null;
      try { k = typeof u.konto === 'function' ? u.konto() : null; } catch (e) { k = null; }
      return k && typeof k === 'object' ? k : null;
    }

    function eingeloggt() {
      var k = konfig();
      if (!k || k.eingeloggt !== true || abgemeldet) return false;
      var s = konto();
      if (s && typeof s.eingeloggt === 'function') {
        try { return s.eingeloggt() === true; } catch (e) { return true; }
      }
      return true;
    }

    function kontoAktiv() {
      return eingeloggt() && !kontoAus && !!basis() && typeof u.holen === 'function';
    }

    // ------------------------------------------------------------------ Ereignisse

    function melde(name, daten) {
      (hoerer[name] || []).slice().forEach(function (fn) {
        try { fn(daten); } catch (e) { /* ein Hoerer darf die Schicht nie stoppen */ }
      });
    }

    function on(name, fn) {
      if (!hat(hoerer, name) || typeof fn !== 'function') return leer;
      hoerer[name].push(fn);
      return function () {
        var i = hoerer[name].indexOf(fn);
        if (i !== -1) hoerer[name].splice(i, 1);
      };
    }

    // ------------------------------------------------------------------ Merker (nur Status und Zeit, nie Profildaten)

    function speicher() {
      if (speicherOk !== undefined) return speicherOk;
      speicherOk = null;
      try {
        var s = typeof u.speicher === 'function' ? u.speicher() : null;
        if (s) {
          s.setItem(MERKER + ':probe', '1');
          s.removeItem(MERKER + ':probe');
          speicherOk = s;
        }
      } catch (e) {
        speicherOk = null;
      }
      return speicherOk;
    }

    function merker() {
      var s = speicher();
      if (!s) return null;
      try { return leseMerker(s.getItem(MERKER), jetztMs()); } catch (e) { return null; }
    }

    function setzeMerker(status) {
      var s = speicher();
      if (!s) return false;
      try {
        s.setItem(MERKER, merkerText(status, jetztMs()));
        return true;
      } catch (e) {
        return false;
      }
    }

    function entferneMerker() {
      var s = speicher();
      if (!s) return;
      try { s.removeItem(MERKER); } catch (e) { /* nichts zu tun */ }
    }

    // ------------------------------------------------------------------ Proxy-Anfragen (nur /profil)

    function anfrage(methode, koerper) {
      var opt = { method: methode, credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
      if (koerper !== undefined) {
        opt.headers['Content-Type'] = 'application/json';
        opt.body = JSON.stringify(koerper);
      }
      var p;
      try { p = u.holen(basis() + '/profil', opt); } catch (e) { return P.resolve({ netz: true }); }
      return P.resolve(p).then(function (antwort) {
        var status = antwort && typeof antwort.status === 'number' ? antwort.status : 0;
        var text = antwort && typeof antwort.text === 'function' ? antwort.text() : '';
        return P.resolve(text).then(function (t) {
          var daten = null;
          try { daten = t ? JSON.parse(t) : null; } catch (e) { daten = null; }
          return { status: status, daten: istObjekt(daten) ? daten : null };
        }, function () { return { status: status, daten: null }; });
      }, function () { return { netz: true }; });
    }

    function erfolg(r) {
      return !r.netz && r.status >= 200 && r.status < 300 && !!r.daten && r.daten.ok === true;
    }

    // Fehlschlag einordnen; 401 und fehlender App-Proxy gelten fuer die ganze Seite
    function fehlschlag(r, wobei) {
      var art = fehlerArt(r);
      if (art === 'nicht_angemeldet') abgemeldet = true;
      if (art === 'konto') kontoAus = true;
      var feld = art === 'ungueltig' && r.daten && typeof r.daten.feld === 'string' ? r.daten.feld : null;
      var erg = { ok: false, fehler: art, status: r.netz ? 0 : r.status, feld: feld };
      melde('fehler', { wobei: wobei, fehler: art, feld: feld });
      return erg;
    }

    function ohneAnfrage() {
      return P.resolve({ ok: false, fehler: eingeloggt() ? 'konto' : 'nicht_angemeldet', status: 0, feld: null });
    }

    // ------------------------------------------------------------------ Vertrag: lesen, speichern, loeschen

    // Ergebnis des letzten Lesens (auch ein Fehlschlag: die Kontoseite zeigt ihn, statt endlos neu zu laden);
    // nur ein Erfolg wird fuer die Seite wiederverwendet
    function lesen(optionen) {
      var frisch = !!(optionen && optionen.frisch);
      if (!kontoAktiv()) return ohneAnfrage();
      if (laufend) return laufend;
      if (stand && stand.ok && !frisch) return P.resolve(stand);
      var p = anfrage('GET').then(function (r) {
        if (!erfolg(r)) {
          stand = fehlschlag(r, 'lesen');
          return stand;
        }
        var erg = {
          ok: true,
          profil: ausServer(r.daten.profil),
          aktualisiert_am: iso(r.daten.aktualisiert_am),
          hinweis_gesehen_am: iso(r.daten.hinweis_gesehen_am)
        };
        stand = erg;
        melde('gelesen', { profil: erg.profil, aktualisiert_am: erg.aktualisiert_am });
        return erg;
      });
      laufend = p;
      p.then(function () { laufend = null; zeichneBereiche(); }, function () { laufend = null; zeichneBereiche(); });
      return p;
    }

    function speichern(werte) {
      var g = pruefeEingabe(werte, false);
      if (g.fehler.length) return P.resolve({ ok: false, fehler: 'ungueltig', status: 0, feld: g.fehler[0].feld });
      if (!kontoAktiv()) return ohneAnfrage();
      return anfrage('PUT', { profil: g.profil }).then(function (r) {
        if (!erfolg(r)) return fehlschlag(r, 'speichern');
        var am = iso(r.daten.aktualisiert_am) || new Date(jetztMs()).toISOString();
        var vorherGesehen = stand && stand.ok ? stand.hinweis_gesehen_am : null;
        stand = { ok: true, profil: g.profil, aktualisiert_am: am, hinweis_gesehen_am: vorherGesehen || am };
        setzeMerker('vorhanden');
        melde('gespeichert', { profil: g.profil, aktualisiert_am: am });
        zeichneBereiche();
        return { ok: true, profil: g.profil, aktualisiert_am: am };
      });
    }

    function loeschen() {
      if (!kontoAktiv()) return ohneAnfrage();
      return anfrage('DELETE').then(function (r) {
        if (!erfolg(r)) return fehlschlag(r, 'loeschen');
        stand = { ok: true, profil: null, aktualisiert_am: null, hinweis_gesehen_am: null };
        // Wer seine Angaben loescht, soll auf dieser Anmeldung nicht sofort wieder gefragt werden
        setzeMerker('spaeter');
        melde('geloescht', {});
        zeichneBereiche();
        return { ok: true };
      });
    }

    // ------------------------------------------------------------------ DOM-Bausteine (createElement, kein HTML-Text)

    function baue(doc, tag, attr, kinder) {
      var el = doc.createElement(tag);
      if (attr) {
        Object.keys(attr).forEach(function (k) {
          var v = attr[k];
          if (v === null || v === undefined || v === false) return;
          if (k === 'text') el.textContent = v;
          else if (k === 'klasse') el.className = v;
          else if (k === 'hidden') el.hidden = true;
          else el.setAttribute(k, v === true ? '' : String(v));
        });
      }
      (kinder || []).forEach(function (c) {
        if (c) el.appendChild(typeof c === 'string' ? doc.createTextNode(c) : c);
      });
      return el;
    }

    function icon(doc, name, groesse, klasse) {
      var NS = 'http://www.w3.org/2000/svg';
      var svg = doc.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'mv-icon' + (klasse ? ' ' + klasse : ''));
      svg.setAttribute('width', String(groesse));
      svg.setAttribute('height', String(groesse));
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.75');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      ICONS[name].forEach(function (teil) {
        var e = doc.createElementNS(NS, teil[0]);
        Object.keys(teil[1]).forEach(function (k) { e.setAttribute(k, teil[1][k]); });
        svg.appendChild(e);
      });
      return svg;
    }

    function aufWerkzeugSeite() {
      var k = konfig();
      var ziel = k ? sichereUrl(k.werkzeugeUrl) : '';
      var pfad = typeof u.pfad === 'function' ? u.pfad() : '';
      return !ziel || ziel === pfad;
    }

    // Hinweis "Das passiert mit Ihren Angaben" (immer sichtbar; im Dialog mit dem Satz zum Aendern und Loeschen)
    function baueHinweis(doc, imDialog, id) {
      var k = konfig();
      var inhalt = baue(doc, 'div', { klasse: 'mv-hinweis__inhalt' }, [
        baue(doc, 'p', { klasse: 'mv-hinweis__titel', text: TEXT.hinweisTitel }),
        baue(doc, 'p', { text: TEXT.hinweis })
      ]);
      if (imDialog) {
        var satz = baue(doc, 'p', null, [TEXT.hinweisAendernVor]);
        var ziel = k ? sichereUrl(k.werkzeugeUrl) : '';
        if (ziel && !aufWerkzeugSeite()) satz.appendChild(baue(doc, 'a', { href: ziel, text: TEXT.werkzeuge }));
        else satz.appendChild(doc.createTextNode('\u201e' + TEXT.werkzeuge + '\u201c'));
        satz.appendChild(doc.createTextNode(TEXT.hinweisAendernNach));
        inhalt.appendChild(satz);
      }
      inhalt.appendChild(baue(doc, 'p', null, [baue(doc, 'a', { href: DATENSCHUTZ_URL, target: '_blank', rel: 'noopener', text: TEXT.datenschutz })]));
      return baue(doc, 'div', { klasse: 'mv-hinweis ' + (imDialog ? 'mv-konto-profil__hinweis' : 'mv-konto-angaben__hinweis'), role: 'note', id: id || null }, [
        icon(doc, 'info', 20, 'mv-hinweis__icon'),
        inhalt
      ]);
    }

    function feldId(feld) {
      return ID + '-' + feld.replace(/_/g, '-');
    }

    // Label, Eingabe, Hilfe, Fehler; aria-describedby zeigt auf Hilfe und (bei Fehler) Fehler
    function feldRahmen(doc, feld, label, eingabe, opt) {
      var id = feldId(feld);
      var lab = baue(doc, 'label', { klasse: 'mv-konto-profil__label', 'for': id }, [label]);
      if (opt.pflicht) {
        lab.appendChild(doc.createTextNode(' '));
        lab.appendChild(baue(doc, 'span', { klasse: 'mv-konto-profil__pflicht', text: TEXT.pflicht }));
      }
      var rahmen = baue(doc, 'div', { klasse: 'mv-konto-profil__feld' + (opt.breit ? ' mv-konto-profil__feld--breit' : '') }, [lab, eingabe]);
      if (opt.hilfe) rahmen.appendChild(baue(doc, 'p', { klasse: 'mv-konto-profil__hilfe', id: id + '-hilfe', text: opt.hilfe }));
      rahmen.appendChild(baue(doc, 'p', { klasse: 'mv-konto-profil__fehler', id: id + '-fehler', hidden: true }));
      if (opt.hilfe) eingabe.setAttribute('aria-describedby', id + '-hilfe');
      return rahmen;
    }

    function textFeld(doc, feld, label, opt) {
      var e = baue(doc, 'input', {
        klasse: 'mv-konto-profil__eingabe',
        id: feldId(feld),
        name: 'mv-profil-' + feld,
        type: opt.typ || 'text',
        maxlength: opt.maxlength || MAX_TEXT,
        autocomplete: opt.autocomplete || null,
        inputmode: opt.inputmode || null,
        required: !!opt.pflicht,
        'aria-required': opt.pflicht ? 'true' : null,
        'data-mv-konto-profil-feld': feld
      });
      return feldRahmen(doc, feld, label, e, opt);
    }

    function auswahlFeld(doc, feld, label, liste, opt) {
      var e = baue(doc, 'select', {
        klasse: 'mv-konto-profil__eingabe',
        id: feldId(feld),
        name: 'mv-profil-' + feld,
        required: !!opt.pflicht,
        'aria-required': opt.pflicht ? 'true' : null,
        'data-mv-konto-profil-feld': feld
      }, [baue(doc, 'option', { value: '', text: TEXT.bitteWaehlen })]);
      liste.forEach(function (x) { e.appendChild(baue(doc, 'option', { value: x[0], text: x[1] })); });
      return feldRahmen(doc, feld, label, e, opt);
    }

    function kontaktFeld(doc) {
      var id = feldId('kontakt_ok');
      var box = baue(doc, 'input', { type: 'checkbox', id: id, name: 'mv-profil-kontakt', 'aria-describedby': id + '-hilfe', 'data-mv-konto-profil-feld': 'kontakt_ok' });
      return baue(doc, 'div', { klasse: 'mv-konto-profil__feld mv-konto-profil__feld--breit' }, [
        baue(doc, 'label', { klasse: 'mv-konto-profil__check', 'for': id }, [box, baue(doc, 'span', { text: TEXT.kontakt })]),
        baue(doc, 'p', { klasse: 'mv-konto-profil__hilfe', id: id + '-hilfe', text: TEXT.kontaktHilfe })
      ]);
    }

    function baueDialog(doc) {
      var titel = baue(doc, 'h2', { klasse: 'mv-konto-profil__titel', id: ID + '-titel', tabindex: '-1', text: TEXT.titel });
      var felder = baue(doc, 'div', { klasse: 'mv-konto-profil__felder' }, [
        textFeld(doc, 'firma', TEXT.firma, { pflicht: true, autocomplete: 'organization' }),
        textFeld(doc, 'name', TEXT.name, { autocomplete: 'name' }),
        textFeld(doc, 'telefon', TEXT.telefon, { typ: 'tel', autocomplete: 'tel', hilfe: TEXT.telefonHilfe }),
        auswahlFeld(doc, 'branche', TEXT.branche, BRANCHEN, { pflicht: true }),
        textFeld(doc, 'anzahl_automaten', TEXT.anzahl, { inputmode: 'numeric', maxlength: 3, autocomplete: 'off', hilfe: TEXT.anzahlHilfe }),
        auswahlFeld(doc, 'zeitraum', TEXT.zeitraum, ZEITRAEUME, {}),
        kontaktFeld(doc)
      ]);
      var meldung = baue(doc, 'div', { klasse: 'mv-konto-profil__meldung', id: ID + '-meldung', role: 'alert' });
      var speichernKnopf = baue(doc, 'button', { type: 'submit', klasse: 'mv-button mv-button--primary', 'data-mv-konto-profil-speichern': true, text: TEXT.speichern });
      var zweiter = baue(doc, 'button', { type: 'button', klasse: 'mv-button mv-button--secondary', 'data-mv-konto-profil-aktion': 'spaeter', text: TEXT.spaeter });
      var form = baue(doc, 'form', { klasse: 'mv-konto-profil__form', novalidate: true, 'data-mv-konto-profil-form': true }, [
        felder,
        meldung,
        baue(doc, 'div', { klasse: 'mv-buttons mv-konto-profil__knoepfe' }, [speichernKnopf, zweiter])
      ]);
      var box = baue(doc, 'div', { klasse: 'mv-konto-profil__box' }, [
        baue(doc, 'button', { type: 'button', klasse: 'mv-konto-profil__schliessen', 'aria-label': TEXT.schliessen, 'data-mv-konto-profil-aktion': 'schliessen' }, [icon(doc, 'schliessen', 22)]),
        titel,
        baue(doc, 'p', { klasse: 'mv-konto-profil__intro', id: ID + '-intro', text: TEXT.intro }),
        baueHinweis(doc, true, ID + '-hinweis'),
        form
      ]);
      var d = baue(doc, 'dialog', {
        klasse: 'mv-konto-profil',
        id: ID,
        'aria-labelledby': ID + '-titel',
        'aria-describedby': ID + '-intro ' + ID + '-hinweis',
        'data-mv-konto-profil-dialog': true
      }, [box]);
      teile = { titel: titel, form: form, meldung: meldung, speichern: speichernKnopf, zweiter: zweiter };
      return d;
    }

    function stelleAnsageBereit(doc) {
      if (ansageGlobal && ansageGlobal.isConnected !== false) return ansageGlobal;
      ansageGlobal = baue(doc, 'p', { klasse: 'mv-visually-hidden', id: ID + '-ansage', role: 'status', 'aria-live': 'polite' });
      doc.body.appendChild(ansageGlobal);
      return ansageGlobal;
    }

    function stelleDialogBereit() {
      var doc = dok();
      if (!doc || !doc.body) return null;
      if (dlg && dlg.isConnected !== false) return dlg;
      dlg = baueDialog(doc);
      doc.body.appendChild(dlg);
      stelleAnsageBereit(doc);
      return dlg;
    }

    function feldEl(feld) {
      return dlg ? dlg.querySelector('[data-mv-konto-profil-feld="' + feld + '"]') : null;
    }

    function setzeFehler(feld, text) {
      var e = feldEl(feld);
      var f = dlg ? dlg.querySelector('#' + feldId(feld) + '-fehler') : null;
      if (!e) return;
      var hilfe = dlg.querySelector('#' + feldId(feld) + '-hilfe');
      var beschr = [];
      if (hilfe) beschr.push(hilfe.id);
      if (text) {
        e.setAttribute('aria-invalid', 'true');
        if (f) {
          f.textContent = text;
          f.hidden = false;
          beschr.push(f.id);
        }
      } else {
        e.removeAttribute('aria-invalid');
        if (f) {
          f.textContent = '';
          f.hidden = true;
        }
      }
      if (beschr.length) e.setAttribute('aria-describedby', beschr.join(' '));
      else e.removeAttribute('aria-describedby');
    }

    function setzeMeldung(art) {
      if (!teile) return;
      var m = teile.meldung;
      while (m.firstChild) m.removeChild(m.firstChild);
      if (!art) return;
      var doc = m.ownerDocument;
      var absatz = baue(doc, 'p', null, [fehlerText(art)]);
      var k = konfig();
      var login = k ? sichereUrl(k.loginUrl) : '';
      if (art === 'nicht_angemeldet' && login) {
        absatz.appendChild(doc.createTextNode(' '));
        absatz.appendChild(baue(doc, 'a', { href: login, text: TEXT.anmelden }));
      }
      m.appendChild(baue(doc, 'div', { klasse: 'mv-hinweis mv-hinweis--fehler' }, [baue(doc, 'div', { klasse: 'mv-hinweis__inhalt' }, [absatz])]));
    }

    function fuelle(profil) {
      var p = profil || {};
      FELDER.forEach(function (f) {
        var e = feldEl(f);
        if (!e) return;
        if (f === 'kontakt_ok') e.checked = p.kontakt_ok === true;
        else e.value = p[f] === null || p[f] === undefined ? '' : String(p[f]);
        setzeFehler(f, null);
      });
      setzeMeldung(null);
    }

    function werteAusDialog() {
      var w = {};
      FELDER.forEach(function (f) {
        var e = feldEl(f);
        if (!e) return;
        w[f] = f === 'kontakt_ok' ? e.checked === true : e.value;
      });
      return w;
    }

    function setzeBeschaeftigt(an) {
      if (!teile) return;
      if (an) {
        teile.speichern.setAttribute('aria-busy', 'true');
        teile.speichern.setAttribute('aria-disabled', 'true');
      } else {
        teile.speichern.removeAttribute('aria-busy');
        teile.speichern.removeAttribute('aria-disabled');
      }
    }

    function ansage(text) {
      var doc = dok();
      if (!doc || !doc.body) return;
      var a = stelleAnsageBereit(doc);
      a.textContent = text;
    }

    // ------------------------------------------------------------------ Dialog oeffnen und schliessen

    function anderesOffen() {
      var doc = dok();
      if (!doc) return false;
      var offene = doc.querySelectorAll('dialog[open]');
      for (var i = 0; i < offene.length; i++) if (offene[i] !== dlg) return true;
      return false;
    }

    function oeffnen(optionen) {
      var m = optionen && (optionen.modus === 'bearbeiten' || optionen.modus === 'login') ? optionen.modus : 'neu';
      if (!eingeloggt() || kontoAus) return false;
      var d = stelleDialogBereit();
      if (!d) return false;
      if (offen) {
        teile.titel.focus();
        return true;
      }
      modus = m;
      var doc = d.ownerDocument;
      vorher = doc.activeElement && doc.activeElement !== doc.body ? doc.activeElement : null;
      teile.titel.textContent = m === 'bearbeiten' ? TEXT.titelBearbeiten : TEXT.titel;
      teile.zweiter.textContent = m === 'login' ? TEXT.spaeter : TEXT.abbrechen;
      teile.zweiter.setAttribute('data-mv-konto-profil-aktion', m === 'login' ? 'spaeter' : 'abbrechen');
      fuelle(m === 'bearbeiten' && stand && stand.ok ? stand.profil : null);
      setzeBeschaeftigt(false);
      sendet = false;
      offen = true;
      var nativ = false;
      if (typeof d.showModal === 'function') {
        try {
          d.showModal();
          nativ = true;
        } catch (e) {
          nativ = false;
        }
      }
      if (!nativ) {
        d.setAttribute('open', '');
        d.classList.add('mv-konto-profil--ersatz');
        d.setAttribute('aria-modal', 'true');
      }
      // Fokus auf die Ueberschrift: der Hinweis bleibt sichtbar, mobil oeffnet sich keine Tastatur ueber ihm
      teile.titel.focus();
      if (m === 'login') setzeMerker('gezeigt');
      melde('geoeffnet', { modus: m });
      return true;
    }

    function fokusZurueck() {
      var doc = dok();
      if (vorher && vorher.isConnected !== false && typeof vorher.focus === 'function' && doc && doc.contains(vorher)) {
        vorher.focus();
      } else if (doc) {
        // Knopf der Kontoseite wurde beim Neuzeichnen ersetzt: auf den Hauptknopf des ersten Bereichs
        var ziel = doc.querySelector('[data-mv-konto-profil] [data-mv-konto-profil-aktion="bearbeiten"], [data-mv-konto-profil] [data-mv-konto-profil-aktion="ergaenzen"]');
        if (ziel) ziel.focus();
      }
      vorher = null;
    }

    function schliessen(art) {
      if (!offen || !dlg) return false;
      var war = modus;
      offen = false;
      sendet = false;
      if (dlg.hasAttribute('open')) {
        if (typeof dlg.close === 'function' && !dlg.classList.contains('mv-konto-profil--ersatz')) {
          try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); }
        } else {
          dlg.removeAttribute('open');
        }
      }
      dlg.classList.remove('mv-konto-profil--ersatz');
      dlg.removeAttribute('aria-modal');
      if (war === 'login' && art !== 'gespeichert') setzeMerker('spaeter');
      modus = null;
      fokusZurueck();
      melde('geschlossen', { modus: war, art: art || 'abbrechen' });
      return true;
    }

    function absenden() {
      if (!offen || sendet) return;
      var g = pruefeEingabe(werteAusDialog(), true);
      FELDER.forEach(function (f) { setzeFehler(f, null); });
      setzeMeldung(null);
      if (g.fehler.length) {
        g.fehler.forEach(function (x) { setzeFehler(x.feld, feldFehlerText(x.feld, x.art)); });
        var erstes = feldEl(g.fehler[0].feld);
        if (erstes) erstes.focus();
        return;
      }
      sendet = true;
      setzeBeschaeftigt(true);
      speichern(g.profil).then(function (r) {
        sendet = false;
        setzeBeschaeftigt(false);
        if (!offen) return;
        if (r.ok) {
          schliessen('gespeichert');
          ansage(TEXT.gespeichert);
          return;
        }
        if (r.fehler === 'ungueltig' && r.feld && FELDER.indexOf(r.feld) !== -1) {
          setzeFehler(r.feld, r.feld === 'anzahl_automaten' ? TEXT.fehlerAnzahl : TEXT.fehlerFeld);
          var e = feldEl(r.feld);
          if (e) e.focus();
          return;
        }
        setzeMeldung(r.fehler);
      });
    }

    // ------------------------------------------------------------------ Erstabfrage nach dem Login

    function pruefen() {
      if (!konfig()) return P.resolve('aus');
      if (!eingeloggt()) {
        entferneMerker();
        return P.resolve('gast');
      }
      var editor = false;
      try { editor = typeof u.editor === 'function' && u.editor() === true; } catch (e) { editor = false; }
      var pfad = typeof u.pfad === 'function' ? u.pfad() : '';
      if (editor || ausgenommen(pfad) || !speicher()) return P.resolve('ausgenommen');
      if (merker()) return P.resolve('merker');
      return lesen().then(function (r) {
        if (!r.ok) {
          if (r.fehler === 'nicht_angemeldet') {
            entferneMerker();
            return 'gast';
          }
          if (r.fehler === 'konto') setzeMerker('fehler');
          return r.fehler;
        }
        if (r.profil) {
          setzeMerker('vorhanden');
          return 'vorhanden';
        }
        if (merker()) return 'merker';
        if (anderesOffen() || offen) return 'belegt';
        return oeffnen({ modus: 'login' }) ? 'geoeffnet' : 'belegt';
      });
    }

    // ------------------------------------------------------------------ Kontoseite (Container von Paket A-3)

    function bereichVon(el) {
      for (var i = 0; i < bereiche.length; i++) if (bereiche[i].el === el) return bereiche[i];
      return null;
    }

    function baueBereich(el) {
      var doc = el.ownerDocument;
      zaehler += 1;
      var id = 'mv-konto-angaben-' + zaehler;
      // Ueberschrift: Ebene 2 (Standard), 3 oder 4; "0" = ohne (die Kontoseite bringt eine eigene mit)
      var roh = el.getAttribute('data-mv-konto-profil-ebene');
      var ebene = roh === null || roh === '' ? 2 : Number(roh);
      if (ebene !== 0 && !(ebene >= 2 && ebene <= 4 && Math.floor(ebene) === ebene)) ebene = 2;
      var abschnitt = baue(doc, 'section', { klasse: 'mv-konto-angaben' });
      if (ebene >= 2 && ebene <= 4) {
        abschnitt.setAttribute('aria-labelledby', id + '-titel');
        // Kopf wie die Baender der Kontoseite (A-3: header.mv-bereich__kopf, Ueberschrift mit Theme-Klasse)
        abschnitt.appendChild(baue(doc, 'header', { klasse: 'mv-bereich__kopf' }, [
          baue(doc, 'h' + ebene, { klasse: 'h3 mv-bereich__titel mv-konto-angaben__titel', id: id + '-titel', text: TEXT.bereichTitel })
        ]));
      } else {
        abschnitt.setAttribute('aria-label', TEXT.bereichTitel);
      }
      var inhalt = baue(doc, 'div', { klasse: 'mv-konto-angaben__inhalt', 'data-mv-konto-angaben-inhalt': true });
      var ansageEl = baue(doc, 'p', { klasse: 'mv-visually-hidden', role: 'status', 'aria-live': 'polite', 'data-mv-konto-angaben-ansage': true });
      abschnitt.appendChild(inhalt);
      abschnitt.appendChild(baueHinweis(doc, false, null));
      abschnitt.appendChild(ansageEl);
      while (el.firstChild) el.removeChild(el.firstChild);
      el.appendChild(abschnitt);
      var b = { el: el, id: id, inhalt: inhalt, ansage: ansageEl, rueckfrage: false, meldung: null, fokus: null };
      bereiche.push(b);
      return b;
    }

    function knopf(doc, aktion, text, art) {
      return baue(doc, 'button', { type: 'button', klasse: 'mv-button mv-button--' + art + ' mv-button--auto', 'data-mv-konto-profil-aktion': aktion, text: text });
    }

    function zeichneBereich(b) {
      var doc = b.el.ownerDocument;
      if (!konfig() || !eingeloggt()) {
        b.el.hidden = true;
        return;
      }
      b.el.hidden = false;
      var x = b.inhalt;
      while (x.firstChild) x.removeChild(x.firstChild);
      var r = laufend ? null : stand;
      // Ohne Proxy (oder nach 403/404) gibt es nichts zu laden: gleich den Fehler zeigen, nie "wird geladen" stehen lassen
      if (!r && !laufend && !kontoAktiv()) r = { ok: false, fehler: 'konto' };
      if (!r) {
        x.appendChild(baue(doc, 'p', { klasse: 'mv-konto-angaben__text', text: TEXT.laedt }));
        if (!laufend) lesen();
        return;
      }
      if (!r.ok) {
        if (r.fehler === 'nicht_angemeldet') {
          b.el.hidden = true;
          return;
        }
        x.appendChild(baue(doc, 'div', { klasse: 'mv-hinweis mv-hinweis--fehler' }, [baue(doc, 'div', { klasse: 'mv-hinweis__inhalt' }, [baue(doc, 'p', { text: TEXT.fehlerLaden })])]));
        if (!kontoAus) x.appendChild(baue(doc, 'div', { klasse: 'mv-buttons mv-konto-angaben__knoepfe' }, [knopf(doc, 'nochmal', TEXT.nochmal, 'secondary')]));
        return;
      }
      if (!r.profil) {
        b.rueckfrage = false;
        x.appendChild(baue(doc, 'p', { klasse: 'mv-konto-angaben__text', text: TEXT.leer }));
        x.appendChild(baue(doc, 'div', { klasse: 'mv-buttons mv-konto-angaben__knoepfe' }, [knopf(doc, 'ergaenzen', TEXT.ergaenzen, 'primary')]));
      } else {
        var liste = baue(doc, 'dl', { klasse: 'mv-konto-angaben__liste' });
        [['firma', TEXT.firma], ['name', TEXT.name], ['telefon', TEXT.telefon], ['branche', TEXT.branche], ['anzahl_automaten', TEXT.anzahlKurz], ['zeitraum', TEXT.zeitraum], ['kontakt_ok', TEXT.kontaktKurz]].forEach(function (z) {
          liste.appendChild(baue(doc, 'div', { klasse: 'mv-konto-angaben__zeile', 'data-mv-konto-angaben-feld': z[0] }, [
            baue(doc, 'dt', { klasse: 'mv-konto-angaben__begriff', text: z[1] }),
            baue(doc, 'dd', { klasse: 'mv-konto-angaben__wert', text: anzeigeWert(z[0], r.profil) })
          ]));
        });
        x.appendChild(liste);
        var zt = zeitText(r.aktualisiert_am, jetztMs());
        if (zt) x.appendChild(baue(doc, 'p', { klasse: 'mv-konto-angaben__stand', text: TEXT.zuletzt + ' ' + zt }));
        if (b.rueckfrage) {
          var frageId = b.id + '-frage';
          var meldung = baue(doc, 'div', { klasse: 'mv-konto-angaben__meldung', role: 'alert' });
          if (b.meldung) meldung.appendChild(baue(doc, 'div', { klasse: 'mv-hinweis mv-hinweis--fehler' }, [baue(doc, 'div', { klasse: 'mv-hinweis__inhalt' }, [baue(doc, 'p', { text: b.meldung })])]));
          x.appendChild(baue(doc, 'div', { klasse: 'mv-konto-angaben__rueckfrage', role: 'group', 'aria-labelledby': frageId }, [
            baue(doc, 'p', { klasse: 'mv-konto-angaben__text', id: frageId, text: TEXT.rueckfrage }),
            baue(doc, 'div', { klasse: 'mv-buttons mv-konto-angaben__knoepfe' }, [knopf(doc, 'loeschen-ja', TEXT.loeschenJa, 'primary'), knopf(doc, 'loeschen-nein', TEXT.abbrechen, 'secondary')]),
            meldung
          ]));
        } else {
          x.appendChild(baue(doc, 'div', { klasse: 'mv-buttons mv-konto-angaben__knoepfe' }, [knopf(doc, 'bearbeiten', TEXT.bearbeiten, 'secondary'), knopf(doc, 'loeschen', TEXT.loeschen, 'ghost')]));
        }
      }
      if (b.fokus) {
        var f = x.querySelector('[data-mv-konto-profil-aktion="' + b.fokus + '"]');
        b.fokus = null;
        if (f) f.focus();
      }
    }

    function zeichneBereiche() {
      bereiche = bereiche.filter(function (b) { return b.el.isConnected !== false; });
      bereiche.forEach(zeichneBereich);
    }

    function anzeigen(container) {
      if (!container || typeof container.querySelector !== 'function' || !container.ownerDocument) return null;
      var b = bereichVon(container) || baueBereich(container);
      zeichneBereich(b);
      return container;
    }

    function bindeAlle(wurzel) {
      if (!wurzel || typeof wurzel.querySelectorAll !== 'function') return;
      var liste = wurzel.querySelectorAll('[data-mv-konto-profil]');
      for (var i = 0; i < liste.length; i++) anzeigen(liste[i]);
    }

    // ------------------------------------------------------------------ Ereignisse der Seite (Delegation auf document)

    function klick(e) {
      var t = e && e.target && typeof e.target.closest === 'function' ? e.target.closest('[data-mv-konto-profil-aktion]') : null;
      if (!t) return;
      var aktion = t.getAttribute('data-mv-konto-profil-aktion');
      if (aktion === 'spaeter' || aktion === 'abbrechen' || aktion === 'schliessen') {
        if (dlg && dlg.contains(t)) {
          e.preventDefault();
          schliessen(aktion);
        }
        return;
      }
      var b = bereichVon(t.closest('[data-mv-konto-profil]'));
      if (!b) return;
      e.preventDefault();
      if (aktion === 'ergaenzen') oeffnen({ modus: 'neu' });
      else if (aktion === 'bearbeiten') oeffnen({ modus: 'bearbeiten' });
      else if (aktion === 'loeschen') {
        b.rueckfrage = true;
        b.meldung = null;
        b.fokus = 'loeschen-nein';
        zeichneBereich(b);
      } else if (aktion === 'loeschen-nein') {
        b.rueckfrage = false;
        b.meldung = null;
        b.fokus = 'loeschen';
        zeichneBereich(b);
      } else if (aktion === 'loeschen-ja') {
        if (t.getAttribute('aria-busy') === 'true') return;
        t.setAttribute('aria-busy', 'true');
        loeschen().then(function (r) {
          if (r.ok) {
            b.rueckfrage = false;
            b.meldung = null;
            b.fokus = 'ergaenzen';
            zeichneBereiche();
            b.ansage.textContent = TEXT.geloescht;
          } else {
            b.meldung = TEXT.fehlerLoeschen;
            b.fokus = 'loeschen-nein';
            zeichneBereich(b);
          }
        });
      } else if (aktion === 'nochmal') {
        stand = null;
        lesen({ frisch: true });
        b.fokus = null;
        zeichneBereich(b);
      }
    }

    function absendenEreignis(e) {
      var f = e && e.target;
      if (!f || typeof f.hasAttribute !== 'function' || !f.hasAttribute('data-mv-konto-profil-form')) return;
      e.preventDefault();
      absenden();
    }

    function eingabe(e) {
      var t = e && e.target;
      if (!offen || !t || typeof t.getAttribute !== 'function' || !dlg || !dlg.contains(t)) return;
      var feld = t.getAttribute('data-mv-konto-profil-feld');
      if (feld && t.getAttribute('aria-invalid') === 'true') setzeFehler(feld, null);
    }

    function fokussierbare() {
      var liste = dlg ? dlg.querySelectorAll(FOKUSSIERBAR) : [];
      var out = [];
      for (var i = 0; i < liste.length; i++) if (!liste[i].closest('[hidden]')) out.push(liste[i]);
      return out;
    }

    // Escape schliesst wie "Spaeter"; Tab bleibt im Dialog (auch ohne showModal)
    function taste(e) {
      if (!offen || !dlg || !e) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        schliessen('esc');
        return;
      }
      if (e.key !== 'Tab') return;
      var liste = fokussierbare();
      if (!liste.length) return;
      var doc = dlg.ownerDocument;
      var aktiv = doc.activeElement;
      var erstes = liste[0];
      var letztesEl = liste[liste.length - 1];
      if (!dlg.contains(aktiv)) {
        e.preventDefault();
        erstes.focus();
      } else if (e.shiftKey && aktiv === erstes) {
        e.preventDefault();
        letztesEl.focus();
      } else if (!e.shiftKey && aktiv === letztesEl) {
        e.preventDefault();
        erstes.focus();
      }
    }

    // Natives Escape (cancel) und Schliessen durch den Browser (close): gleiche Buchfuehrung wie "Spaeter"
    function abbruch(e) {
      if (!e || e.target !== dlg || !offen) return;
      e.preventDefault();
      schliessen('esc');
    }

    // close kommt im Browser als eigene Aufgabe nach dem Schliessen: ist der Dialog inzwischen wieder offen (neu
    // geoeffnet), gehoert das Ereignis zum alten Schliessen und bleibt ohne Wirkung
    function zu(e) {
      if (!e || e.target !== dlg || !offen || dlg.hasAttribute('open')) return;
      schliessen('esc');
    }

    function sektion(e) {
      bindeAlle(e && e.target);
    }

    function start() {
      bindeAlle(dok());
      return pruefen();
    }

    return {
      VERSION: VERSION,
      TEXT: TEXT,
      BRANCHEN: BRANCHEN,
      ZEITRAEUME: ZEITRAEUME,
      eingeloggt: eingeloggt,
      lesen: lesen,
      speichern: speichern,
      loeschen: loeschen,
      oeffnen: oeffnen,
      schliessen: function () { return schliessen('abbrechen'); },
      anzeigen: anzeigen,
      pruefen: pruefen,
      on: on,
      _klick: klick,
      _absenden: absendenEreignis,
      _eingabe: eingabe,
      _taste: taste,
      _abbruch: abbruch,
      _zu: zu,
      _sektion: sektion,
      _start: start
    };
  }

  var logik = {
    VERSION: VERSION,
    MERKER: MERKER,
    MERKER_STATUS: MERKER_STATUS,
    FEHLER_PAUSE_MS: FEHLER_PAUSE_MS,
    MAX_TEXT: MAX_TEXT,
    FELDER: FELDER,
    EREIGNISSE: EREIGNISSE,
    BRANCHEN: BRANCHEN,
    ZEITRAEUME: ZEITRAEUME,
    TEXT: TEXT,
    ICONS: ICONS,
    DATENSCHUTZ_URL: DATENSCHUTZ_URL,
    zeitText: zeitText,
    einzeilig: einzeilig,
    pruefeEingabe: pruefeEingabe,
    ausServer: ausServer,
    leseMerker: leseMerker,
    merkerText: merkerText,
    fehlerArt: fehlerArt,
    ausgenommen: ausgenommen,
    anzeigeWert: anzeigeWert,
    fehlerText: fehlerText,
    feldFehlerText: feldFehlerText,
    erzeuge: erzeuge
  };

  // Node (Tests): nur hier gibt es module.exports, im Browser nie
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Teil 3: Browser
  // ===========================================================================================

  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.kontoProfil) return;

  var api = erzeuge({
    konfig: function () { return window.mvKonto; },
    konto: function () { return window.MVKonto || null; },
    speicher: function () { return window.localStorage; },
    holen: typeof window.fetch === 'function' ? function (url, opt) { return window.fetch(url, opt); } : null,
    jetzt: function () { return Date.now(); },
    dokument: document,
    pfad: function () { return window.location.pathname; },
    editor: function () { return !!(window.Shopify && window.Shopify.designMode); },
    Promise: window.Promise
  });
  api.logik = logik;
  MV.kontoProfil = api;

  document.addEventListener('click', function (e) { api._klick(e); });
  document.addEventListener('submit', function (e) { api._absenden(e); });
  document.addEventListener('input', function (e) { api._eingabe(e); });
  document.addEventListener('change', function (e) { api._eingabe(e); });
  document.addEventListener('keydown', function (e) { api._taste(e); });
  document.addEventListener('cancel', function (e) { api._abbruch(e); }, true);
  document.addEventListener('close', function (e) { api._zu(e); }, true);
  document.addEventListener('shopify:section:load', function (e) { api._sektion(e); });

  // Nach dem Buendel (konto.js steht dahinter): an MVKonto haengen, Kontoseite fuellen, Erstabfrage
  function los() {
    var k = window.MVKonto;
    if (k && typeof k === 'object' && !k.profil) k.profil = api;
    api._start();
  }

  function nachBuendel() {
    if (typeof window.Promise === 'function') window.Promise.resolve().then(los);
    else los();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', nachBuendel);
  else nachBuendel();
})();
